import React, { useState, useEffect } from "react";
import { auth, db } from "../api/firebase";
import { doc, getDoc } from "firebase/firestore";
import DisplayGroupMember from "./DisplayGroupMember";

const GroupMembers = ({ members }) => {
  const [founder, setFounder] = useState(null);
  const [ments, setMents] = useState([]);
  const [isApplies, setIsApplies] = useState([]);

  const [originalCount, setOriginalCount] = useState(0);
  const [filteredCount, setFilteredCount] = useState(0);

  // FirestoreでisVillagerを確認
  const checkVillager = async (member) => {
    try {
      const userRef = doc(db, "users", member.uid); // uidを利用
      const snap = await getDoc(userRef);
      if (snap.exists()) {
        const data = snap.data();
        return data.isVillager !== false; // falseは非表示
      }
      return true; // ドキュメントが無い場合は表示
    } catch (e) {
      console.error("ユーザ取得失敗:", e);
      return true;
    }
  };

  useEffect(() => {
    const init = async () => {
      if (!members) return;
      setOriginalCount(members.length);

      const filteredFounder = [];
      const filteredMents = [];
      const filteredApplies = [];

      for (const u of members) {
        if (await checkVillager(u)) {
          if (u.isOwner === true) {
            filteredFounder.push(u);
          } else if (
            u.isOwner === false &&
            u.isApplication === false &&
            u.isMember === true
          ) {
            filteredMents.push(u);
          } else if (
            u.isOwner === false &&
            u.isApplication === true &&
            u.isMember === false
          ) {
            filteredApplies.push(u);
          }
        }
      }

      setFounder(filteredFounder[0] || null);
      setMents(filteredMents);
      setIsApplies(filteredApplies);

      const totalFiltered =
        (filteredFounder.length ? 1 : 0) +
        filteredMents.length +
        filteredApplies.length;
      setFilteredCount(totalFiltered);

      // console.log("👥 members 全体:", members.length);
      // console.log("✅ isVillager チェック後:", totalFiltered);
    };

    init();
  }, [members]);

  return (
    <>
      {/* 件数確認 */}
      {/* <div className="my-4 text-sm text-gray-500">
        メンバー総数: {originalCount} ／ 表示対象: {filteredCount}
      </div> */}

      {/* 代表 */}
      <div>
        <div className="my-8 text-xl">代表</div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
          {founder && <DisplayGroupMember member={founder} />}
        </div>
      </div>

      {/* メンバー */}
      <div>
        <div className="my-8 text-xl">メンバー</div>
        {ments.length === 0 ? (
          <div>メンバーはまだいません</div>
        ) : (
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
            {ments.map((member) => (
              <DisplayGroupMember key={member.uid} member={member} />
            ))}
          </div>
        )}
      </div>

      {/* 申請中 */}
      {founder?.uid === auth.currentUser?.uid && (
        <div>
          <div className="my-8 text-xl">申請中</div>
          {isApplies.length === 0 ? (
            <div>申請中のメンバーはいません</div>
          ) : (
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
              {isApplies.map((member) => (
                <DisplayGroupMember key={member.uid} member={member} />
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default GroupMembers;
